import { NgModule } from '@angular/core';
import { DxPieChartModule } from 'devextreme-angular';
import { CoreModule } from 'src/app/core/core.module';
import * as Report from './report.components';

const COMPONENTS = [Report.CieComponent, Report.PatientsByDoctorComponent];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [CoreModule, DxPieChartModule],
  entryComponents: [],
  exports: [...COMPONENTS],
})
export class ReportModule {}
